import Lang from "lang.js";
const locale = window.App.locale ?? "pl";
const messages = {};
if (typeof window.App.i18n != "undefined") {
    // transform i18n object
    for (const el in window.App.i18n) {
        messages[locale + "." + el] = window.App.i18n[el];
    }
}
const i18n = new Lang({
    messages,
    locale,
});
export { i18n };
